/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState } from 'react';
import {
  MDBPopconfirm,
  MDBPopconfirmMessage,
} from 'mdb-react-ui-kit'
import "../style/index.css"
import "../style/css/popup.css"


interface PopUpProps {
    onDeleteClick: () => void; 
  }

const PopUp: React.FC<PopUpProps> = ({onDeleteClick}) => {

  const [isOpen, setIsOpen] = useState(false);

    return (
    <MDBPopconfirm 
    className='popUp'
    modal btnChildren='Supprimer' 
    btnClassName='me-1' 
    id="button"
    placement='right' 
    cancelBtnClasses ='popUp__btn'
    cancelBtnText ='Annuler'
    confirmBtnClasses='popUp__btn'
    confirmBtnText="Supprimer"
    onClick={() => setIsOpen(true)}
    onClose={() => setIsOpen(false)}  
    onConfirm={onDeleteClick}>
  
      <MDBPopconfirmMessage className='popUp__modal'> Confirmez vous la suppression ?</MDBPopconfirmMessage>

    </MDBPopconfirm>
    )}
export default PopUp

